// extracted by mini-css-extract-plugin
export var sliderStyle = "carousel_with_arrows_wrapper-module--sliderStyle--ScSbz";